import React from "react";
import NavLazyImage from "../nav-lazy-image";
var HelpPopover = function HelpPopover(_ref) {
  var isMount = _ref.isMount,
    onlineService = _ref.onlineService,
    image = _ref.image;
  return /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-right-popover help'
  }, /*#__PURE__*/React.createElement("ul", {
    className: 'help-list'
  }, /*#__PURE__*/React.createElement("li", {
    className: 'help-list-item'
  }, /*#__PURE__*/React.createElement("div", {
    className: "ib-pointer",
    onClick: function onClick() {
      window.open(onlineService, "serviceWindow", "width=800,height=600");
    }
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    className: 'help-list-icon',
    src: "".concat(image, "/header/icon_1.png"),
    alt: "\u806F\u7D61\u5BA2\u670D"
  }), /*#__PURE__*/React.createElement("p", {
    className: 'help-list-text'
  }, "\u806F\u7D61\u5BA2\u670D"))), /*#__PURE__*/React.createElement("li", {
    className: 'help-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: 'https://www.8891.com.tw/help-index.html',
    target: '_blank',
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    className: 'help-list-icon',
    src: "".concat(image, "/header/icon_2.png"),
    alt: "\u65B0\u624B\u6307\u5357"
  }), /*#__PURE__*/React.createElement("p", {
    className: 'help-list-text'
  }, "\u65B0\u624B\u6307\u5357"))), /*#__PURE__*/React.createElement("li", {
    className: 'help-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: 'https://www.8891.com.tw/help-index.html',
    target: '_blank',
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    className: 'help-list-icon',
    src: "".concat(image, "/header/icon_3.png"),
    alt: "\u8CE3\u8ECA\u6B65\u9A5F"
  }), /*#__PURE__*/React.createElement("p", {
    className: 'help-list-text'
  }, "\u8CE3\u8ECA\u6B65\u9A5F"))), /*#__PURE__*/React.createElement("li", {
    className: 'help-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: 'https://www.8891.com.tw/help-price.html',
    target: '_blank',
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    className: 'help-list-icon',
    src: "".concat(image, "/header/icon_14.png"),
    alt: "\u6536\u8CBB\u6A19\u6E96"
  }), /*#__PURE__*/React.createElement("p", {
    className: 'help-list-text'
  }, "\u6536\u8CBB\u6A19\u6E96"))), /*#__PURE__*/React.createElement("li", {
    className: 'help-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: 'https://www.8891.com.tw/help-d_1.html',
    target: '_blank',
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    className: 'help-list-icon',
    src: "".concat(image, "/header/icon_4.png"),
    alt: "\u4ED8\u6B3E\u65B9\u5F0F"
  }), /*#__PURE__*/React.createElement("p", {
    className: 'help-list-text'
  }, "\u4ED8\u6B3E\u65B9\u5F0F"))), /*#__PURE__*/React.createElement("li", {
    className: 'help-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: 'https://www.8891.com.tw/member-index.html',
    target: '_blank',
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    className: 'help-list-icon',
    src: "".concat(image, "/header/icon_5.png"),
    alt: "\u6703\u54E1\u4E2D\u5FC3"
  }), /*#__PURE__*/React.createElement("p", {
    className: 'help-list-text'
  }, "\u6703\u54E1\u4E2D\u5FC3"))), /*#__PURE__*/React.createElement("li", {
    className: 'help-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: 'https://c.8891.com.tw/ads/apply',
    target: '_blank',
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    className: 'help-list-icon',
    src: "".concat(image, "/header/icon_12.png"),
    alt: "\u5EE3\u544A\u5408\u4F5C"
  }), /*#__PURE__*/React.createElement("p", {
    className: 'help-list-text'
  }, "\u5EE3\u544A\u5408\u4F5C"))), /*#__PURE__*/React.createElement("li", {
    className: 'help-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: 'https://businessadmin.8891.com.tw/ad/view',
    target: '_blank',
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    className: 'help-list-icon',
    src: "".concat(image, "/header/icon_15.png"),
    alt: "\u540D\u55AE\u5EE3\u544A"
  }), /*#__PURE__*/React.createElement("p", {
    className: 'help-list-text'
  }, "\u540D\u55AE\u5EE3\u544A"))), /*#__PURE__*/React.createElement("li", {
    className: 'help-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: 'https://bbs.8891.com.tw/',
    target: '_blank',
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    className: 'help-list-icon',
    src: "".concat(image, "/header/icon_13.png"),
    alt: "\u6C7D\u8ECA\u793E\u7FA4"
  }), /*#__PURE__*/React.createElement("p", {
    className: 'help-list-text'
  }, "\u6C7D\u8ECA\u793E\u7FA4")))));
};
export default HelpPopover;